import { orderAssistLogger } from '../components/app/logger';
import { PatientSourceVaultToken } from '@getvim/patient-lookup-service/types';

class VimPatientIdsManager {
  private patientSourceVaultTokens: PatientSourceVaultToken[] | undefined;


  public getPatientSourceVaultTokens(): PatientSourceVaultToken[] | undefined {
    return this.patientSourceVaultTokens;
  }

  public handleUpdateIds(
    patientSourceVaultTokens: PatientSourceVaultToken[],
  ): void {
    if (!patientSourceVaultTokens) {
      orderAssistLogger.warning(
        'patientSourceVaultTokens are undefined',
        {
          patientSourceVaultTokens,
        },
      );
    }
    this.patientSourceVaultTokens = patientSourceVaultTokens;
  }

  public resetIds() {
    this.patientSourceVaultTokens = undefined;
  }
}
export const vimPatientIdsManager = new VimPatientIdsManager();
